// snippet::snippet-systembase[TS]
import { Component, ComponentListener, EcsSystem, Entity } from '@inter-ikea-core/core';
import { ComponentListenerImpl } from './ComponentListenerImpl';

/**
 * A base class for systems that will listen to one type of component.
 * This system can be enabled or disabled and will then start/stop listening.
 *
 * Note that in order for the system to work it must be registered with the EntityManager
 * and enabled.
 */
export abstract class SystemBase<TComponent extends Component> implements EcsSystem {
  protected _componentListeners: ComponentListener[];
  public get componentListeners(): ComponentListener[] {
    return this._componentListeners;
  }
  abstract readonly doingChangesOnComponent: number[];
  abstract readonly systemsBeforeMe: string[] | null;
  abstract readonly systemsAfterMe: string[] | null;
  readonly mandatoryComponents: number[] | null = null;
  readonly ignoreEntitiesWithComponents: number[] | null = null;

  private _isEnabled: boolean;
  public get isEnabled(): boolean {
    return this._isEnabled;
  }
  abstract readonly id: string;

  constructor(componentId: number) {
    this._isEnabled = true;

    this.onAddComponent = this.onAddComponent.bind(this);
    this.onUpdateComponent = this.onUpdateComponent.bind(this);
    this.onRemoveComponent = this.onRemoveComponent.bind(this);

    this._componentListeners = [
      new ComponentListenerImpl(
        this,
        componentId,
        this.onAddComponent,
        this.onUpdateComponent,
        this.onRemoveComponent
      )
    ];
  }

  protected abstract onAddComponent(entity: Entity, newComponent: TComponent): void;
  protected abstract onUpdateComponent(
    entity: Entity,
    oldComponent: TComponent,
    newComponent: TComponent
  ): void;
  protected abstract onRemoveComponent(entity: Entity, oldComponent: TComponent): void;

  enable(): void {
    this._isEnabled = true;
  }

  disable(): void {
    this._isEnabled = false;
  }

  onRegister(): void {}
  onUnregister(): void {}
}
// end::snippet-systembase
